<div class="member-search-component">
    <form [formGroup]="searchForm" novalidate>
        <div class="form-group form-horizontal input-with-clear">
            @if (!isBusy) {
                <i class="fa fa-search search-icon" aria-hidden="true"> </i>
            }
            <input
                maxlength="100"
                class="form-control search-control"
                type="text"
                formControlName="expression"
                hznTestId="member-search-input"
                (keyup.enter)="onEnter()"
                placeholder="Type in first name, last name or memberId"
            />
            @if (showClear()) {
                <span class="input-with-clear-img" (click)="onClear()"
                    >&#10006;</span
                >
            }
            @if (isBusy) {
                <bcu-local-spinner
                    [size]="25"
                    [visible]="isBusy"
                ></bcu-local-spinner>
            }
        </div>
    </form>

    <div #resultsElement>
        @if (resultsVisible) {
            <div
                class="results"
                [ngClass]="{ 'results-visible': resultsVisible }"
                infinite-scroll
                [infiniteScrollDistance]="0.2"
                [infiniteScrollThrottle]="0"
                [infiniteScrollDisabled]="isBusy"
                (scrolled)="onScroll()"
                [scrollWindow]="false"
            >
                @for (item of results; track item) {
                    <div
                        class="result-item"
                        hznTestId="member-search-result"
                        (click)="onItemClick(item)"
                    >
                        <div class="row result-title">
                            <div class="cold-md-12">
                                <div>{{ item.fullName }}</div>
                                <div>{{ item.memberId }}</div>
                            </div>
                        </div>
                    </div>
                }
                @if (!hasItems) {
                    <div>
                        <div class="row no-result-row">
                            <div class="cold-md-12">
                                {{ "MembershipSearch.noResults" | translate }}
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
</div>
